(() => {
  if (window.syrenProductEnhancementsLoaded) return;
  window.syrenProductEnhancementsLoaded = true;
  const rootUrl = window.Shopify?.routes?.root || '/';
  const init = () => {
    document.querySelectorAll('[data-syren-pick-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const card = form.closest('[data-syren-pick]');
      const group = form.closest('.syren-picks');
      const select = form.querySelector('select[name="id"]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const photo = card.querySelector('.syren-pick__image img');
        if (photo && option.dataset.image) { photo.removeAttribute('srcset'); photo.src = option.dataset.image; }
        card.querySelector('[data-pick-price]').textContent = option.dataset.price || '';
        const compare = card.querySelector('[data-pick-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
        card.querySelector('[role="status"]').textContent = '';
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.busy || !form.reportValidity()) return;
        const id = form.elements.id.value;
        if (!id) return;
        const button = form.querySelector('button');
        const status = card.querySelector('[role="status"]');
        form.dataset.busy = 'true';
        button.disabled = true;
        status.textContent = '';
        try {
          const response = await fetch(rootUrl + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || group.dataset.errorLabel);
          status.textContent = group.dataset.addedLabel;
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', {bubbles:true,detail:{product:data.items?.[0] || data,addToCartBtn:button}}));
        } catch (error) {
          status.textContent = error.message || group.dataset.errorLabel;
        } finally {
          delete form.dataset.busy;
          button.disabled = false;
        }
      });
    });
    document.querySelectorAll('[data-syren-sticky]').forEach(bar => {
      if (bar.dataset.ready) return;
      const main = document.getElementById(bar.dataset.mainId);
      const form = document.getElementById(bar.dataset.formId);
      const mainButton = form?.querySelector('[data-add-to-cart]');
      if (!main || !form || !mainButton) return;
      bar.dataset.ready = 'true';
      const variants = JSON.parse(bar.querySelector('[data-sticky-variants]').textContent);
      const selectors = [...bar.querySelectorAll('[data-sticky-option]')];
      const button = bar.querySelector('[data-sticky-submit]');
      let current = null;
      let passedButton = false;
      let wasBusy = false;
      const update = () => {
        const values = selectors.map(select => select.value);
        const complete = values.every(Boolean);
        current = selectors.length ? variants.find(variant => variant.options.every((value,index) => value === values[index])) : variants[0];
        button.disabled = complete && (!current || !current.available);
        button.textContent = !complete ? bar.dataset.chooseLabel : !current ? bar.dataset.unavailableLabel : !current.available ? bar.dataset.soldLabel : bar.dataset.addLabel;
        bar.querySelector('[data-sticky-selection]').textContent = complete && selectors.length ? values.join(' / ') : '';
        if (current) {
          bar.querySelector('[data-sticky-price]').textContent = current.price;
          const compare = bar.querySelector('[data-sticky-compare]');
          compare.textContent = current.compare;
          compare.hidden = !current.compare;
        }
      };
      const showOptions = () => {
        const index = Math.max(0,selectors.findIndex(select => !select.value));
        const control = main.querySelector('[data-variant-input][data-index="option' + (index+1) + '"]');
        const target = control?.closest('.variant-wrapper') || mainButton;
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
        const focus = target.querySelector('select,input:not([type="hidden"]),button') || mainButton;
        focus.focus({preventScroll:true});
      };
      const visibility = () => {
        const cartOpen = document.documentElement.classList.contains('js-drawer-open') || document.body.classList.contains('js-drawer-open') || !!document.querySelector('#kaching-cart[aria-hidden="false"],.kaching-cart--open');
        const hide = !passedButton || cartOpen;
        if (bar.hidden !== hide) bar.hidden = hide;
        if (document.body.classList.contains('syren-sticky-active') === hide) document.body.classList.toggle('syren-sticky-active',!hide);
        if (!hide) document.body.style.setProperty('--syren-sticky-height',bar.offsetHeight+'px');
      };
      selectors.forEach((select,index) => select.addEventListener('change', () => {
        const candidates = [...main.querySelectorAll('[data-variant-input][data-index="option' + (index+1) + '"]')];
        const source = candidates.find(input => input.tagName === 'SELECT' || input.value === select.value);
        if (source && select.value) {
          if (source.type === 'radio') source.click();
          else {source.value = select.value;source.dispatchEvent(new Event('change',{bubbles:true}));}
        }
        update();
      }));
      main.addEventListener('change', event => {
        const source = event.target.closest('[data-variant-input]');
        if (!source) return;
        const index = Number(source.dataset.index.replace('option','')) - 1;
        if (selectors[index]) selectors[index].value = source.value;
        update();
      });
      button.addEventListener('click', () => {
        if (selectors.some(select => !select.value) || !current) {showOptions();return;}
        const actual = form.querySelector('[name="id"]')?.value;
        if (String(current.id) !== String(actual)) {showOptions();return;}
        if (!current.available || mainButton.disabled) return;
        mainButton.click();
      });
      new MutationObserver(() => {
        const busy = mainButton.classList.contains('btn--loading');
        if (busy) {button.disabled=true;wasBusy=true;}
        else if (wasBusy) {wasBusy=false;update();}
      }).observe(mainButton,{attributes:true,attributeFilter:['class','disabled']});
      const observer = new IntersectionObserver(entries => {
        passedButton = entries[0].boundingClientRect.bottom <= 0;
        visibility();
      },{threshold:0});
      observer.observe(mainButton);
      new MutationObserver(visibility).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
      new MutationObserver(visibility).observe(document.body,{attributes:true,attributeFilter:['class']});
      window.addEventListener('resize',visibility,{passive:true});
      document.addEventListener('shopify:section:unload',event => {if(event.target.contains(main)){observer.disconnect();document.body.classList.remove('syren-sticky-active');}});
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

(() => {
 const rules=[['.kaching-cart-item__price-info > .kaching-cart__badge',{display:'flex',background:'transparent',color:'#18a76e','font-size':'15px','font-weight':'600','margin-top':'0px',padding:'0'}],['.kaching-cart__cart-discounts-title,.kaching-cart__cart-discounts-amount',{'font-size':'15px','font-weight':'500',color:'#193e2c','-webkit-text-fill-color':'#193e2c'}],['.kaching-cart-item__total-final',{color:'#ee0000','font-size':'20px','font-weight':'700'}]];
 let scheduled=false;
 const apply=()=>{scheduled=false;rules.forEach(([selector,styles])=>document.querySelectorAll(selector).forEach(el=>Object.entries(styles).forEach(([key,value])=>{if(el.style.getPropertyValue(key)!==value||el.style.getPropertyPriority(key)!=='important')el.style.setProperty(key,value,'important')})))};
 const start=()=>{apply();new MutationObserver(()=>{if(!scheduled){scheduled=true;requestAnimationFrame(apply)}}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

/* Miriam cart: shipping and returns strip. */
(()=>{const html="<div class=\"miriam-cart-trust__item\"><svg aria-hidden=\"true\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\"><path d=\"m12 2 9 5v10l-9 5-9-5V7l9-5Z M3 7l9 5 9-5 M12 12v10 M7.5 4.5l9 5\"/></svg><span>החזרות תוך 30 יום</span></div><div class=\"miriam-cart-trust__item\"><img src=\"https://cdn.shopify.com/s/files/1/0935/0712/5584/files/Israel_Postal_Company_logo_in_Hebrew.png?v=1792762282\" width=\"52\" height=\"28\" alt=\"דואר ישראל\"><span>משלוח חינם</span></div>";let pending=false;const apply=()=>{pending=false;document.querySelectorAll('#kaching-cart .kaching-cart__trust-badges-list').forEach(el=>{if(el.querySelector('.miriam-cart-trust__item'))return;el.classList.add('miriam-cart-trust');el.setAttribute('dir','rtl');el.setAttribute('lang','he');el.innerHTML=html;});};const start=()=>{apply();new MutationObserver(()=>{if(!pending){pending=true;requestAnimationFrame(apply);}}).observe(document.body,{childList:true,subtree:true});};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();})();

/* Miriam cart summary. Timer is managed by Kaching Cart. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const productCache = new Map();
  let signature = '', sequence = 0, pending;
  const money = (amount, currency) => new Intl.NumberFormat('he-IL', {style:'currency',currency}).format(amount / 100);
  const summary = async () => {
    const serial = ++sequence;
    try {
      const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      const bases = await Promise.all(cart.items.map(async item => {
        let base = item.original_line_price;
        try {
          const key = cart.currency + ':' + item.handle;
          if (!productCache.has(key)) productCache.set(key, fetch(root + 'products/' + encodeURIComponent(item.handle) + '.js').then(r => {if(!r.ok) throw Error('product');return r.json();}));
          const product = await productCache.get(key);
          const variant = product.variants.find(v => String(v.id) === String(item.variant_id));
          if (variant && Number.isFinite(variant.compare_at_price)) base = Math.max(base, variant.compare_at_price * item.quantity);
        } catch (_) {}
        return base;
      }));
      if (serial !== sequence) return;
      const button = document.querySelector('#kaching-cart__checkout-button');
      if (!button) return;
      let box = document.querySelector('#miriam-cart-summary');
      if (!cart.item_count) {box?.remove();return;}
      if (!box) {
        box = document.createElement('div');
        box.id = 'miriam-cart-summary';
        box.dir = 'rtl';
        box.lang = 'he';
        box.innerHTML = '<div class="miriam-cart-summary__discount"><span class="miriam-cart-summary__label"><span>הנחות</span><span data-miriam-discount-badges></span></span><bdi data-miriam-savings></bdi></div><div class="miriam-cart-summary__total"><strong>סה״כ לתשלום</strong><bdi data-miriam-total></bdi></div>';
        button.before(box);
      }
      const saved = Math.max(0, bases.reduce((a,b)=>a+b,0) - cart.total_price);
      box.querySelector('[data-miriam-savings]').textContent = money(-saved,cart.currency);
      box.querySelector('[data-miriam-total]').textContent = money(cart.total_price,cart.currency);
      cart.items.forEach((item,index) => { const row = Array.from(document.querySelectorAll('#kaching-cart .kaching-cart-item')).find(el => el.dataset.lineKey === item.key); const info = row?.querySelector('.kaching-cart-item__price-info'); const saving = Math.max(0,bases[index]-item.final_line_price); if(!info || !saving) return; let badge = info.querySelector(':scope > .kaching-cart__badge'); if(!badge){badge=document.createElement('div');badge.className='kaching-cart__badge';info.append(badge);} const text = 'חסכת ' + new Intl.NumberFormat('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}).format(saving/100) + ' NIS'; if(badge.textContent.trim()!==text)badge.textContent=text; });
      const badges = box.querySelector('[data-miriam-discount-badges]');
      const applied = (cart.cart_level_discount_applications || []).concat((cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(a => Object.assign({}, a.discount_application, {total_allocated_amount:a.amount})))).filter(d =>
        d.value_type === 'percentage' &&
        d.type === 'automatic' && [10,15,20,25].includes(Number(d.value)) && Number(d.total_allocated_amount) > 0
      );
      const rates = [...new Set(applied.map(d => Number(d.value)).concat((cart.items || []).filter(item => item.original_line_price > item.final_line_price).map(item => Math.round((1 - item.final_line_price / item.original_line_price) * 100)).filter(rate => [10,15,20,25].includes(rate))))];
      const badgeKey = rates.join(',');
      if (badges && badges.dataset.rates !== badgeKey) {
        badges.dataset.rates = badgeKey;
        badges.replaceChildren(...rates.map(rate => {
          const badge = document.createElement('span');
          badge.className = 'miriam-cart-summary__badge';
          badge.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M20 13l-7 7a2 2 0 0 1-3 0L2 12V3h9l9 8a2 2 0 0 1 0 2Z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg><span><bdi>' + rate + '%</bdi> הנחה נוספת</span>';
          return badge;
        }));
      }
    } catch (_) {}
  };
  const check = () => {
    const cart = document.querySelector('#kaching-cart');
    if (!cart) return;
    const next = Array.from(cart.querySelectorAll('.kaching-cart-item')).map(el => el.dataset.lineKey + ':' + el.querySelector('input')?.value).join('|') + '/' + cart.querySelector('.kaching-cart__checkout-button-label')?.textContent + '/' + Array.from(cart.querySelectorAll('.kaching-cart-item__price-info,.kaching-cart__cart-discounts')).map(el=>el.textContent).join('|');
    if (next !== signature || (cart.querySelector('.kaching-cart-item') && !cart.querySelector('#miriam-cart-summary'))) {
      signature = next;
      clearTimeout(pending);
      pending = setTimeout(summary,200);
    }
  };
  const start = () => {
    check();
    new MutationObserver(check).observe(document.body,{childList:true,subtree:true,characterData:true});
    document.addEventListener('change',e=>{if(e.target.closest('#kaching-cart'))check();});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

/* Miriam: concise checkout label; total remains in the summary above. */
(() => {
  const apply = () => {
    const label = document.querySelector('#kaching-cart__checkout-button .kaching-cart__checkout-button-label');
    if (label && document.querySelector('#miriam-cart-summary') && label.textContent !== 'לתשלום') label.textContent = 'לתשלום';
  };
  const start = () => {
    apply();
    new MutationObserver(apply).observe(document.body, {childList:true,subtree:true,characterData:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
})();
